import React, { useState } from 'react';
import { number } from 'prop-types';
import { isEmpty } from 'lodash';
import { useMediaQuery } from 'react-responsive';
import { MEDIA_GRID_SM } from '../../../../../../../../../shared/constants';
import { gigsBySeller } from '../../../../../../../utils/api/gigs';
import raiseError from '../../../../../../../../../shared/utils/raiseError';
import AvailableServicesPopover from './AvailableServicesPopover';
import AvailableServicesModal from './AvailableServicesModal';

const AvailableServices = ({ sellerId, total }) => {
    const [gigs, setGigs] = useState([]);
    const [loading, setLoading] = useState(true);

    const isMobile = useMediaQuery({ maxWidth: MEDIA_GRID_SM });

    const fetchGigsBySeller = async () => {
        if (!isEmpty(gigs) && !loading) {
            return;
        }

        try {
            const gigs = await gigsBySeller(sellerId);

            setGigs(gigs);
        } catch (error) {
            raiseError();
        }

        setLoading(false);
    };

    const Component = isMobile ? AvailableServicesModal : AvailableServicesPopover;

    return (
        <Component
            className="available-services"
            gigs={gigs}
            total={total}
            loading={loading}
            onOpen={fetchGigsBySeller}
        />
    );
};

AvailableServices.propTypes = {
    sellerId: number,
    total: number,
};

export default AvailableServices;
